import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  FaUser,
  FaIdCard,
  FaCalendarAlt,
  FaCalendarCheck,
  FaSearch,
  FaArrowLeft,
  FaSave,
  FaArrowRight,
  FaFileExcel,
} from "react-icons/fa";
import {
  Box,
  HStack,
  Text,
  Icon,
  Divider,
  Button,
  Spinner,
  Input,
  Image,
  Center,
  Table,
  Thead,
  Tr,
  Th,
  Tbody,
  Td,
  Badge,
  Tooltip,
  useToast,
  Flex,
  VStack,
  Heading,
  SimpleGrid,
  useDisclosure,
} from "@chakra-ui/react";
import { fetchPapeleta } from "../apis/get-apontamentos-motoristas";
import TabelaAgrupada from "../components/TabelaAgrupada";
import TabelaHistoricoAlteracoes from "../components/TabelaHistoricoAlteracoes";
import motorasAppLogo from "../assets/motoras app logo.png";
import LogotipoNexus from "../assets/Logotipo_Nexus2.png";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import * as XLSX from "xlsx";
import { getAlteracoesPapeleta } from "../apis/get-alteracoes";
import {
  formatDate,
  calcularDuracao,
  calcularDiferencaRefeicao,
  calcularDiferencaDescanso,
  calcularHE50,
  calcularHE100,
  calcularAdicionalNoturno,
  converterParaMinutos,
} from "../helpers/Functions";
import { useSSLErrorHandler } from "../hooks/useSSLErrorHandler";
import SSLCertificateHelper from "../components/SSLCertificateHelper";

import {
  MdEditNote,
  MdHistory,
  MdAddCircleOutline,
  MdDeleteSweep,
  MdWarning,
  MdRefresh,
  MdExpandMore,
  MdExpandLess,
} from "react-icons/md";

function Apontamentos() {
  const { state } = useLocation();
  const motorista = state?.motorista;
  const navigate = useNavigate();
  const toast = useToast();
  const { sslError, sslHelperDisclosure, handleError } = useSSLErrorHandler();

  const [papeletaData, setPapeletaData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [loadingLogs, setLoadingLogs] = useState(false);
  const [loadingPDF, setLoadingPDF] = useState(false);
  const [loadingXLSX, setLoadingXLSX] = useState(false);
  const [error, setError] = useState(null);
  const [primeiroApto, setPrimeiroApto] = useState("");
  const [ultimoApto, setUltimoApto] = useState("");
  const [logsData, setLogsData] = useState([]);
  const [mostrarSomenteUltimas, setMostrarSomenteUltimas] = useState(true);
  const [mostrarDetalhesCompletos, setMostrarDetalhesCompletos] =
    useState(false);
  const [mostrarTodosLogs, setMostrarTodosLogs] = useState(false);
  const [buscaInicialRealizada, setBuscaInicialRealizada] = useState(false);
  const [activeMotorista, setActiveMotorista] = useState(null);

  // Função para calcular as datas
  const calcularDatas = (ultimoApto) => {
    if (ultimoApto) {
      const dataFinal = new Date(ultimoApto);
      const dataInicial = new Date(dataFinal);
      dataInicial.setDate(dataFinal.getDate() - 21);

      return {
        dataInicial: dataInicial.toISOString().split("T")[0],
        dataFinal: dataFinal.toISOString().split("T")[0],
      };
    }
    return { dataInicial: "", dataFinal: "" };
  };

  // Carregar as datas salvas do sessionStorage ao montar o componente
  useEffect(() => {
    console.log("🔍 useEffect de inicialização executado");
    const savedPrimeiroApto = sessionStorage.getItem("primeiroApto");
    const savedUltimoApto = sessionStorage.getItem("ultimoApto");
    const savedMotoristaCodigo = sessionStorage.getItem("motoristaCodigo");
    const savedMotoristaNome = sessionStorage.getItem("motoristaNome");
    const savedMotoristaUltimoApto = sessionStorage.getItem(
      "motoristaUltimoApto"
    );

    console.log("📅 Datas salvas no sessionStorage:", {
      savedPrimeiroApto,
      savedUltimoApto,
    });
    console.log("👤 Motorista from state:", motorista);
    console.log("👤 Motorista salvo (sessionStorage):", {
      savedMotoristaCodigo,
      savedMotoristaNome,
    });

    let motoristaToUse = null;

    // Prioritize motorista from route state (first navigation to Apontamentos)
    if (motorista?.codigo) {
      motoristaToUse = motorista;
      sessionStorage.setItem("motoristaCodigo", motoristaToUse.codigo);
      sessionStorage.setItem("motoristaNome", motoristaToUse.nome);
      if (motoristaToUse.ultimo_apto) {
        sessionStorage.setItem(
          "motoristaUltimoApto",
          motoristaToUse.ultimo_apto
        );
      }
    } else if (savedMotoristaCodigo && savedMotoristaNome) {
      // Fallback to motorista from sessionStorage (e.g., after navigating back)
      motoristaToUse = {
        codigo: savedMotoristaCodigo,
        nome: savedMotoristaNome,
        ultimo_apto: savedMotoristaUltimoApto || null,
      };
    }
    setActiveMotorista(motoristaToUse);

    // Initialize dates
    if (savedPrimeiroApto && savedUltimoApto) {
      console.log("✅ Usando datas salvas do sessionStorage");
      setPrimeiroApto(savedPrimeiroApto);
      setUltimoApto(savedUltimoApto);
    } else if (motoristaToUse?.ultimo_apto) {
      console.log("🔄 Calculando datas com base no último apto do motorista");
      const { dataInicial, dataFinal } = calcularDatas(
        motoristaToUse.ultimo_apto
      );
      setPrimeiroApto(dataInicial);
      setUltimoApto(dataFinal);
      sessionStorage.setItem("primeiroApto", dataInicial);
      sessionStorage.setItem("ultimoApto", dataFinal);
    } else if (motoristaToUse) {
      console.log(
        "⚠️ Motorista conhecido, mas sem ultimo_apto ou datas salvas. Calculando datas padrão."
      );
      const today = new Date();
      const dataFinal = today.toISOString().split("T")[0];
      const dataInicial = new Date(today);
      dataInicial.setDate(today.getDate() - 21);
      setPrimeiroApto(dataInicial.toISOString().split("T")[0]);
      setUltimoApto(dataFinal);
      sessionStorage.setItem(
        "primeiroApto",
        dataInicial.toISOString().split("T")[0]
      );
      sessionStorage.setItem("ultimoApto", dataFinal);
    }
  }, [motorista]);

  // Efeito separado para fazer a busca quando as datas ou motorista mudarem
  useEffect(() => {
    console.log("🔍 useEffect de busca executado", {
      primeiroApto,
      ultimoApto,
      activeMotoristaCodigo: activeMotorista?.codigo,
      buscaInicialRealizada,
    });

    if (
      primeiroApto &&
      ultimoApto &&
      activeMotorista?.codigo &&
      !buscaInicialRealizada
    ) {
      console.log("🚀 Iniciando busca inicial");
      handleSearch(primeiroApto, ultimoApto);
      setBuscaInicialRealizada(true);
    }
  }, [
    primeiroApto,
    ultimoApto,
    activeMotorista?.codigo,
    buscaInicialRealizada,
  ]);

  // Função para chamar a API com os dados das datas
  const handleSearch = async (dataInicial, dataFinal) => {
    if (!activeMotorista?.codigo) {
      console.warn(
        "Não foi possível realizar a busca: Código do motorista não disponível."
      );
      setError("Código do motorista não disponível para busca.");
      setLoading(false);
      setLoadingLogs(false);
      return;
    }
    setLoading(true);
    setLoadingLogs(true);
    setError(null);

    try {
      const response = await fetchPapeleta(
        activeMotorista.codigo,
        dataInicial,
        dataFinal
      );
      setPapeletaData(response);
      console.log("response", response);

      const response_logs = await getAlteracoesPapeleta(
        activeMotorista.codigo,
        dataInicial,
        dataFinal
      );
      setLogsData(response_logs);
      console.log("response_logs", response_logs);
    } catch (err) {
      if (!handleError(err)) {
        setError("Erro ao carregar os dados da papeleta.");
      }
    } finally {
      setLoading(false);
      setLoadingLogs(false);
    }
  };

  // Função para busca manual (quando o usuário clica no botão Pesquisar)
  const handleManualSearch = () => {
    if (primeiroApto && ultimoApto && activeMotorista?.codigo) {
      handleSearch(primeiroApto, ultimoApto);
    }
  };

  const handleGoBack = () => {
    navigate(-1);
  };

  const handleDateChange = (setter, key, value) => {
    console.log("📝 handleDateChange chamado:", {
      setter: setter.name,
      key,
      value,
    });
    setter(value);
    sessionStorage.setItem(key, value);
    console.log("💾 Data salva no sessionStorage:", { key, value });
  };

  // Função para processar dados da tabela para PDF
  const processarDadosTabelaPDF = () => {
    if (!papeletaData) return [];

    // Agrupar os dados pela propriedade "data_inicial" (mesma lógica da TabelaAgrupada)
    const agrupadosPorData = papeletaData.reduce((acc, item) => {
      if (!acc[item.data_inicial]) {
        acc[item.data_inicial] = [];
      }
      acc[item.data_inicial].push(item);
      return acc;
    }, {});

    const diasOrdenados = Object.keys(agrupadosPorData).sort(
      (a, b) => new Date(a) - new Date(b)
    );

    return diasOrdenados.map((dataInicial) => {
      const eventos = agrupadosPorData[dataInicial];
      const primeiroEvento = eventos[0];

      // Verificar se é dia especial
      const obs = primeiroEvento.obs_compensada?.trim().toLowerCase();
      const isDiaEspecial = [
        "dsr_noutrocidade",
        "falta",
        "afastamento",
        "ferias",
        "dsr_cg",
      ].includes(obs);
      const isFeriado = obs === "feriado";

      // Calcular valores usando as mesmas funções da TabelaAgrupada
      const jornada = calcularDuracao(
        primeiroEvento.hora_inicial,
        eventos[eventos.length - 1].hora_final
      );

      const refeicao = calcularDiferencaRefeicao(eventos);
      const descanso = calcularDiferencaDescanso(eventos);
      const adicionalNoturno = calcularAdicionalNoturno(eventos);

      const isDomingo = primeiroEvento.semana_texto === "Domingo";
      const isCompensado = primeiroEvento.data_compensada?.trim() !== "";

      // Verificar se não foi trabalhado com compensação
      const isNaoTrabalhadoComCompensacao =
        (!primeiroEvento.hora_inicial || primeiroEvento.hora_inicial === ":") &&
        (!primeiroEvento.hora_final || primeiroEvento.hora_final === ":") &&
        primeiroEvento.data_compensada?.trim() !== "";

      // Aplicar a MESMA lógica de exibição da TabelaAgrupada para HE50
      let he50 = "";
      if (isNaoTrabalhadoComCompensacao) {
        he50 = "";
      } else if (isFeriado) {
        he50 = "00:00";
      } else if (isDiaEspecial) {
        he50 = "";
      } else if (jornada === null && !primeiroEvento.obs_compensada?.trim()) {
        he50 = primeiroEvento.semana_texto === "Sabado" ? "-04:00" : "-08:00";
      } else if (jornada === null) {
        he50 = "00:00";
      } else if (isDomingo && !isCompensado) {
        he50 = "00:00";
      } else {
        const he50Calculado = calcularHE50(
          jornada,
          refeicao,
          descanso,
          primeiroEvento.semana_texto === "Sabado" ? "4:00" : "8:00",
          adicionalNoturno
        );
        he50 = he50Calculado === "-8:00" ? "" : he50Calculado || "N/A";
      }

      // Aplicar a MESMA lógica de exibição da TabelaAgrupada para HE100
      let he100 = "";
      if (isNaoTrabalhadoComCompensacao) {
        he100 = "";
      } else if (isDiaEspecial) {
        he100 = "";
      } else if (isFeriado) {
        he100 = calcularHE100(
          jornada,
          refeicao,
          descanso,
          adicionalNoturno,
          isDomingo,
          isFeriado
        );
      } else if (jornada === null || jornada === "00:00") {
        he100 = "00:00";
      } else if (isDomingo && isCompensado) {
        he100 = "00:00";
      } else {
        he100 = calcularHE100(
          jornada,
          refeicao,
          descanso,
          adicionalNoturno,
          isDomingo,
          isFeriado
        );
      }

      // Formatar observação
      const formatarObservacao = (texto) => {
        if (!texto) return "";
        const textoLower = texto.trim().toLowerCase();
        if (textoLower === "dsr_noutrocidade") {
          return "DSR_NOUTRACIDADE";
        }
        return texto;
      };

      return {
        data: dataInicial,
        diaSemana: primeiroEvento.semana_texto.toUpperCase(),
        horaInicio:
          isNaoTrabalhadoComCompensacao || isDiaEspecial
            ? ""
            : primeiroEvento.hora_inicial !== ":"
            ? primeiroEvento.hora_inicial
            : "00:00",
        horaFim:
          isNaoTrabalhadoComCompensacao || isDiaEspecial
            ? ""
            : eventos[eventos.length - 1].hora_final !== ":"
            ? eventos[eventos.length - 1].hora_final
            : "00:00",
        jornada: isNaoTrabalhadoComCompensacao || isDiaEspecial ? "" : jornada,
        normal:
          isNaoTrabalhadoComCompensacao || isDiaEspecial
            ? ""
            : primeiroEvento.semana_texto === "Sabado"
            ? "04:00"
            : "08:00",
        refeicao:
          isNaoTrabalhadoComCompensacao || isDiaEspecial ? "" : refeicao,
        descanso:
          isNaoTrabalhadoComCompensacao || isDiaEspecial ? "" : descanso,
        he50: he50,
        he100: he100,
        adicionalNoturno:
          isNaoTrabalhadoComCompensacao || isDiaEspecial
            ? ""
            : adicionalNoturno,
        observacao: formatarObservacao(
          primeiroEvento.obs_compensada
        ).toUpperCase(),
        cp: (() => {
          // Se for férias, não exibir nada na coluna CP
          if (
            primeiroEvento.obs_compensada?.trim().toLowerCase() === "ferias"
          ) {
            return "";
          }

          // Lógica original para outros casos
          if (
            (primeiroEvento.data_compensada &&
              primeiroEvento.data_compensada !== dataInicial) ||
            primeiroEvento.data_orig_compensacao
          ) {
            return primeiroEvento.data_compensada &&
              primeiroEvento.data_compensada !== dataInicial
              ? formatDate(primeiroEvento.data_compensada)
              : primeiroEvento.data_orig_compensacao
              ? formatDate(primeiroEvento.data_orig_compensacao)
              : "";
          } else {
            return "";
          }
        })(),
        intersticio: "",
        placa: [...new Set(eventos.map((e) => e.placa))].join(", "),
      };
    });
  };

  const handleExportPDF = () => {
    setLoadingPDF(true);

    setTimeout(() => {
      try {
        if (!papeletaData) {
          toast({
            title: "Erro ao exportar",
            description: "Não há dados para exportar",
            status: "error",
            duration: 3000,
            isClosable: true,
          });
          setLoadingPDF(false);
          return;
        }

        // Processar dados da tabela
        const dadosTabela = processarDadosTabelaPDF();

        // Calcular totais para o PDF usando a MESMA lógica da TabelaAgrupada
        const calcularTotaisPDF = () => {
          const totais = {
            he50: 0,
            he100: 0,
            adicionalNoturno: 0,
          };

          const converterMinutosParaHoras = (minutos) => {
            if (minutos === null || minutos === undefined || isNaN(minutos)) {
              return "00:00";
            }

            const isNegativo = minutos < 0;
            const minutosAbsolutos = Math.abs(minutos);
            const horas = Math.floor(minutosAbsolutos / 60)
              .toString()
              .padStart(2, "0");
            const restoMinutos = (minutosAbsolutos % 60)
              .toString()
              .padStart(2, "0");
            const resultado = `${horas}:${restoMinutos}`;

            return isNegativo ? `-${resultado}` : resultado;
          };

          // Função para calcular HE50 (mesma lógica da TabelaAgrupada)
          const calcularHE50Linha = (eventos) => {
            if (!eventos || eventos.length === 0) return "";
            const semana = eventos[0].semana_texto;
            const obs = eventos[0].obs_compensada?.trim().toLowerCase();
            const isFeriado = obs === "feriado";
            const isDiaEspecial = [
              "dsr_cg",
              "dsr_noutrocidade",
              "falta",
              "afastamento",
              "ferias",
            ].includes(obs || "");
            const isNaoTrabalhadoComCompensacao =
              (!eventos[0].hora_inicial || eventos[0].hora_inicial === ":") &&
              (!eventos[0].hora_final || eventos[0].hora_final === ":") &&
              eventos[0].data_compensada?.trim() !== "";

            if (isNaoTrabalhadoComCompensacao) return "";
            if (isDiaEspecial) return "";
            if (isFeriado) return "00:00";

            const duracao = calcularDuracao(
              eventos[0].hora_inicial,
              eventos[eventos.length - 1].hora_final
            );

            if (duracao === null && !eventos[0].obs_compensada?.trim()) {
              return semana === "Sabado" ? "-04:00" : "-08:00";
            }
            if (duracao === null) {
              return "00:00";
            }
            if (semana === "Domingo" && !eventos[0].data_compensada?.trim()) {
              return "00:00";
            }

            const valor = calcularHE50(
              duracao,
              calcularDiferencaRefeicao(eventos),
              calcularDiferencaDescanso(eventos),
              semana === "Sabado" ? "4:00" : "8:00",
              calcularAdicionalNoturno(eventos)
            );
            if (valor === "-8:00") return "";
            return valor || "00:00";
          };

          // Usar a mesma lógica de agrupamento da TabelaAgrupada
          const agrupadosPorData = papeletaData.reduce((acc, item) => {
            if (!acc[item.data_inicial]) {
              acc[item.data_inicial] = [];
            }
            acc[item.data_inicial].push(item);
            return acc;
          }, {});

          const diasOrdenados = Object.keys(agrupadosPorData).sort(
            (a, b) => new Date(a) - new Date(b)
          );

          Object.entries(agrupadosPorData).forEach(([dataInicial, eventos]) => {
            const primeiroEvento = eventos[0];
            const obs = primeiroEvento.obs_compensada?.trim().toLowerCase();
            const semana = primeiroEvento.semana_texto;
            const isFeriado = obs === "feriado";

            const jornada = calcularDuracao(
              primeiroEvento.hora_inicial,
              eventos[eventos.length - 1].hora_final
            );
            const refeicao = calcularDiferencaRefeicao(eventos);
            const descanso = calcularDiferencaDescanso(eventos);
            let adicionalNoturno = calcularAdicionalNoturno(eventos);

            // ⛔ Aplicar a MESMA lógica da TabelaAgrupada: SÓ ignora dias especiais, NÃO ignora jornada 00:00
            const isDiaEspecial = [
              "dsr_noutrocidade",
              "falta",
              "afastamento",
              "ferias",
              "dsr_cg",
            ].includes(obs);

            if (isDiaEspecial) {
              console.log(
                `[PDF TOTALS] ⛔ Ignorado: ${dataInicial} ${semana} ${obs} - Dia especial`
              );
              return;
            }

            const isDomingo = semana === "Domingo";
            const isCompensado = primeiroEvento.data_compensada?.trim() !== "";

            // HE100 só aplica em domingo/feriado quando há jornada > 0 (MESMA lógica da TabelaAgrupada)
            const he100Aplica =
              ((isDomingo && !isCompensado) || isFeriado) &&
              converterParaMinutos(jornada) > 0;
            let he100 = he100Aplica
              ? calcularHE100(
                  jornada,
                  refeicao,
                  descanso,
                  adicionalNoturno,
                  isDomingo,
                  isFeriado
                )
              : "00:00";

            // Usar calcularHE50Linha (MESMA lógica da TabelaAgrupada)
            const he50 = calcularHE50Linha(eventos);

            // Para jornadas nulas ou 00:00, força adicional noturno como 00:00
            if (jornada === "00:00" || jornada === null) {
              adicionalNoturno = "00:00";
            }

            // Somar aos totais usando converterParaMinutos (MESMA lógica da TabelaAgrupada)
            totais.he50 += converterParaMinutos(he50);
            totais.he100 += converterParaMinutos(he100);
            totais.adicionalNoturno += converterParaMinutos(adicionalNoturno);
          });

          const resultado = {
            he50: converterMinutosParaHoras(totais.he50),
            he100: converterMinutosParaHoras(totais.he100),
            adicionalNoturno: converterMinutosParaHoras(
              totais.adicionalNoturno
            ),
          };

          console.log(
            `[PDF TOTALS] 🔥 Total final calculado: HE50 = ${resultado.he50} (${totais.he50} minutos)`
          );
          return resultado;
        };

        const totaisPDF = calcularTotaisPDF();

        // Criar PDF
        const pdf = new jsPDF("l", "mm", "a4");
        const pageWidth = pdf.internal.pageSize.width;
        const pageHeight = pdf.internal.pageSize.height;

        // Garantir fundo branco
        pdf.setFillColor(255, 255, 255);
        pdf.rect(0, 0, pageWidth, pageHeight, "F");

        let yPos = 8;

        // --- TÍTULO ---
        // pdf.setFontSize(16);
        // pdf.setTextColor(0, 0, 0);
        // pdf.setFont("helvetica", "bold");
        // pdf.text("Apontamentos", pageWidth / 2, yPos, { align: "center" });
        // yPos += 8;

        // --- SUBTÍTULO ---
        // pdf.setFontSize(10);
        // pdf.setFont("helvetica", "normal");
        // pdf.setTextColor(80, 80, 80);
        // const subtitulo = `Motorista: ${activeMotorista?.nome} | Período: ${formatDate(primeiroApto)} a ${formatDate(ultimoApto)}`;
        // pdf.text(subtitulo, pageWidth / 2, yPos, { align: "center" });
        // yPos += 12;

        // --- TABELA PRINCIPAL ---
        const colunas = [
          { header: "Dia", key: "data", width: 20, align: "center" },
          { header: "Dia/Sem", key: "diaSemana", width: 25, align: "center" },
          { header: "H Início", key: "horaInicio", width: 20, align: "center" },
          { header: "H Fim", key: "horaFim", width: 20, align: "center" },
          { header: "H Jornada", key: "jornada", width: 22, align: "center" },
          { header: "H Normal", key: "normal", width: 22, align: "center" },
          { header: "Refeição", key: "refeicao", width: 20, align: "center" },
          { header: "Descanso", key: "descanso", width: 20, align: "center" },
          { header: "HE 50%", key: "he50", width: 20, align: "center" },
          { header: "HE 100%", key: "he100", width: 20, align: "center" },
          {
            header: "Ad. Noturno",
            key: "adicionalNoturno",
            width: 18,
            align: "center",
          },
          { header: "Observação", key: "observacao", width: 20, align: "left" },
          { header: "CP", key: "cp", width: 15, align: "center" },
        ];

        const larguraTotal = colunas.reduce((sum, col) => sum + col.width, 0);
        const margemEsquerda = (pageWidth - larguraTotal) / 2;

        // Função para desenhar cabeçalho da tabela
        const desenharCabecalho = (y) => {
          let x = margemEsquerda;
          colunas.forEach((col) => {
            // Desenhar retângulo branco com borda preta
            pdf.setFillColor(255, 255, 255);
            pdf.setDrawColor(0, 0, 0);
            pdf.rect(x, y - 3, col.width, 7, "FD"); // FD = Fill and Draw - diminuído de 8 para 7

            // Desenhar texto preto - centralizado verticalmente
            pdf.setFontSize(8); // Diminuído de 9 para 8
            pdf.setTextColor(0, 0, 0);
            pdf.setFont("helvetica", "bold");
            const texto = col.header;
            let textX = x + col.width / 2;
            if (col.align === "left") textX = x + 2;
            pdf.text(texto, textX, y + 2, { align: col.align }); // Ajustado de y + 1 para y + 2

            x += col.width;
          });
        };

        // Função para desenhar linha da tabela
        const desenharLinha = (dados, y) => {
          let x = margemEsquerda;
          colunas.forEach((col) => {
            // Desenhar retângulo branco com borda preta
            pdf.setFillColor(255, 255, 255);
            pdf.setDrawColor(0, 0, 0);
            pdf.rect(x, y - 2, col.width, 6, "FD"); // FD = Fill and Draw - diminuído de 6 para 5

            // Desenhar texto preto - centralizado verticalmente
            pdf.setFontSize(7); // Diminuído de 8 para 7
            pdf.setTextColor(0, 0, 0);
            pdf.setFont("helvetica", "normal");
            const valor = dados[col.key] || "";
            const texto = col.key === "data" ? formatDate(valor) : valor;
            const textoWidth = pdf.getTextWidth(texto);
            let textX = x + col.width / 2;
            if (col.align === "left") textX = x + 2;

            // Truncar texto se necessário
            if (textoWidth > col.width - 2) {
              let textoTruncado = texto;
              while (
                pdf.getTextWidth(textoTruncado + "...") > col.width - 2 &&
                textoTruncado.length > 0
              ) {
                textoTruncado = textoTruncado.slice(0, -1);
              }
              pdf.text(textoTruncado + "...", textX, y + 2, {
                align: col.align,
              }); // Ajustado de y + 1 para y + 2
            } else {
              pdf.text(texto, textX, y + 2, { align: col.align }); // Ajustado de y + 1 para y + 2
            }

            x += col.width;
          });
        };

        // Desenhar cabeçalho
        desenharCabecalho(yPos);
        yPos += 6;

        // Desenhar linhas de dados
        dadosTabela.forEach((linha, index) => {
          // Verificar se cabe na página
          if (yPos + 6 > pageHeight - 30) {
            // Não quebrar página - ajustar fonte para caber tudo
            const alturaDisponivel = pageHeight - 30 - yPos;
            const linhasRestantes = dadosTabela.length - index;
            const alturaPorLinha = alturaDisponivel / linhasRestantes;

            if (alturaPorLinha < 5) {
              // Reduzir fonte para caber
              pdf.setFontSize(6);
            }
          }

          desenharLinha(linha, yPos);
          yPos += 5; // Diminuído de 6 para 5
        });

        // Desenhar linha de totais
        yPos += 2;
        let x = margemEsquerda;

        // Desenhar fundo da linha de totais (cinza escuro)
        pdf.setFillColor(220, 220, 220);
        pdf.rect(margemEsquerda, yPos - 2, larguraTotal, 8, "F");

        // Desenhar bordas
        pdf.setDrawColor(0, 0, 0);
        pdf.rect(margemEsquerda, yPos - 2, larguraTotal, 8, "S");

        // Texto "Total" nas primeiras colunas - centralizado verticalmente
        pdf.setFontSize(9); // Diminuído de 10 para 9
        pdf.setTextColor(0, 0, 0);
        pdf.setFont("helvetica", "bold");
        pdf.text("Total", x + 10, yPos + 3); // Ajustado de yPos + 2 para yPos + 3
        x += 20; // Dia
        x += 25; // Dia/Sem
        x += 20; // H Início
        x += 20; // H Fim
        x += 22; // H Jornada
        x += 22; // H Normal
        x += 20; // Refeição
        x += 20; // Descanso

        // Totais nas colunas HE50, HE100, Ad. Noturno - centralizados verticalmente
        pdf.text(totaisPDF.he50, x + 20 / 2, yPos + 3, { align: "center" }); // Ajustado de yPos + 2 para yPos + 3
        x += 20; // HE 50%
        pdf.text(totaisPDF.he100, x + 20 / 2, yPos + 3, { align: "center" }); // Ajustado de yPos + 2 para yPos + 3
        x += 20; // HE 100%
        pdf.text(totaisPDF.adicionalNoturno, x + 18 / 2, yPos + 3, {
          align: "center",
        }); // Ajustado de yPos + 2 para yPos + 3

        yPos += 10;

        // --- ASSINATURA ---
        pdf.setFontSize(11);
        pdf.setTextColor(0, 0, 0);
        const lineWidth = pdf.getTextWidth("____________________________");
        pdf.text(
          "____________________________",
          (pageWidth - lineWidth) / 2,
          pageHeight - 25
        );
        pdf.text(
          `${activeMotorista?.nome}`,
          (pageWidth - pdf.getTextWidth(activeMotorista?.nome)) / 2,
          pageHeight - 20
        );

        // --- RODAPÉ ---
        pdf.setFontSize(8);
        pdf.setTextColor(120, 120, 120);
        pdf.setFont("helvetica", "normal");

        const centerText = `Gerado em: ${new Date().toLocaleString("pt-BR")}`;
        const centerTextWidth = pdf.getTextWidth(centerText);
        pdf.text(
          centerText,
          (pageWidth - centerTextWidth) / 2,
          pageHeight - 10
        );

        // Identificador do documento no rodapé
        const nomeCompleto = activeMotorista?.nome || "";
        const primeiroUltimoNome =
          nomeCompleto.split(" ").length > 1
            ? `${nomeCompleto.split(" ")[0]} ${
                nomeCompleto.split(" ")[nomeCompleto.split(" ").length - 1]
              }`
            : nomeCompleto;
        const identificadorTexto = `${primeiroUltimoNome} | ${formatDate(
          primeiroApto
        )} a ${formatDate(ultimoApto)} | ${
          mostrarTodosLogs ? "Todos" : "Finais"
        }`;
        const identificadorWidth = pdf.getTextWidth(identificadorTexto);
        pdf.setFontSize(7); // Fonte menor
        pdf.text(
          identificadorTexto,
          pageWidth - 10 - identificadorWidth,
          pageHeight - 10
        );

        // Função para adicionar identificador em todas as páginas
        const adicionarIdentificador = () => {
          const nomeCompleto = activeMotorista?.nome || "";
          const primeiroUltimoNome =
            nomeCompleto.split(" ").length > 1
              ? `${nomeCompleto.split(" ")[0]} ${
                  nomeCompleto.split(" ")[nomeCompleto.split(" ").length - 1]
                }`
              : nomeCompleto;
          const identificadorTexto = `${primeiroUltimoNome} | ${formatDate(
            primeiroApto
          )} a ${formatDate(ultimoApto)} | ${
            mostrarTodosLogs ? "Todos" : "Finais"
          }`;
          const identificadorWidth = pdf.getTextWidth(identificadorTexto);
          pdf.setFontSize(7); // Fonte menor
          pdf.text(
            identificadorTexto,
            pageWidth - 10 - identificadorWidth,
            pageHeight - 10
          );
        };

        // --- LOGS DE ALTERAÇÕES ---
        if (logsData.length > 0) {
          pdf.addPage();
          yPos = 20;
          adicionarIdentificador(); // Adiciona identificador na segunda página

          // Função para encontrar evento correspondente na papeletaData usando id_marcacao
          const encontrarEventoCorrespondente = (log) => {
            if (!papeletaData || !log.id_marcacao) return null;

            // Primeiro tenta encontrar pelo id_marcacao (mais preciso)
            const eventoPorId = papeletaData.find(
              (evento) => evento.id === log.id_marcacao
            );
            if (eventoPorId) return eventoPorId;

            // Se não encontrar, tenta por id_evento + data (fallback)
            return papeletaData.find(
              (evento) =>
                evento.id_evento === log.id_evento &&
                evento.data_inicial === log.data_original
            );
          };

          // Função para obter o nome correto do evento
          const obterNomeEventoCorreto = (log) => {
            // Se temos o evento correspondente na papeleta, usar o nome dele
            const eventoCorrespondente = encontrarEventoCorrespondente(log);
            if (eventoCorrespondente) {
              return (
                eventoCorrespondente.descricao_evento ||
                eventoCorrespondente.nome_evento
              );
            }

            // Caso contrário, usar o nome do log
            return log.nome_evento;
          };

          // Processar logs para PDF (mesma lógica da TabelaHistoricoAlteracoes)
          const processarLogsPDF = () => {
            // Função para agrupar logs por id_marcacao
            const agruparLogsPorMarcacao = (logs) => {
              const grupos = new Map();

              logs.forEach((log) => {
                // Chave única: id_marcacao + data_original + nome_evento
                // Agrupa TODOS os logs do mesmo evento (inserção, alteração, exclusão)
                const chave = `${log.id_marcacao || "sem_marcacao"}_${
                  log.data_original
                }_${log.nome_evento}`;

                if (!grupos.has(chave)) {
                  grupos.set(chave, {
                    id_marcacao: log.id_marcacao,
                    data_original: log.data_original,
                    nome_evento: log.nome_evento,
                    nome_motorista: log.nome_motorista,
                    logs: [],
                    tipo: "Alterado",
                    originalInicial: "",
                    novoInicial: "",
                    originalFinal: "",
                    novoFinal: "",
                  });
                }
                grupos.get(chave).logs.push(log);
              });

              // Processar cada grupo
              grupos.forEach((grupo) => {
                // Ordenar logs por data/hora de alteração (mais recente primeiro)
                const logsOrdenados = grupo.logs.sort((a, b) => {
                  const dataA = new Date(
                    `${a.data_alteracao}T${a.hora_alteracao}`
                  );
                  const dataB = new Date(
                    `${b.data_alteracao}T${b.hora_alteracao}`
                  );
                  return dataB - dataA; // Mais recente primeiro
                });

                // Função para verificar se um log corresponde ao estado final na papeleta
                const logCorrespondeAoEstadoFinal = (log) => {
                  if (!papeletaData || !log.id_marcacao) return false;

                  // Encontrar o evento correspondente na papeleta
                  const eventoPapeleta = papeletaData.find(
                    (evento) => evento.id === log.id_marcacao
                  );
                  if (!eventoPapeleta) return false;

                  // Verificar se os horários do log correspondem aos horários finais da papeleta
                  const campo = log.campo_alteracao;

                  if (
                    campo === "horario_inicial" ||
                    campo === "inserido_inicial"
                  ) {
                    return log.hora_novo === eventoPapeleta.hora_inicial;
                  } else if (
                    campo === "horario_final" ||
                    campo === "inserido_final"
                  ) {
                    return log.hora_novo === eventoPapeleta.hora_final;
                  }

                  return false;
                };

                // Para "Ver apenas alterações finais", filtrar logs que correspondem ao estado final
                if (!mostrarTodosLogs) {
                  // Manter apenas logs que correspondem ao estado final da papeleta
                  grupo.logs = grupo.logs.filter((log) =>
                    logCorrespondeAoEstadoFinal(log)
                  );

                  // Se não há logs que correspondem ao estado final, pular este grupo
                  if (grupo.logs.length === 0) {
                    return;
                  }

                  // Reordenar após filtragem
                  grupo.logs.sort((a, b) => {
                    const dataA = new Date(
                      `${a.data_alteracao}T${a.hora_alteracao}`
                    );
                    const dataB = new Date(
                      `${b.data_alteracao}T${b.hora_alteracao}`
                    );
                    return dataB - dataA;
                  });
                }

                // Verificar se o último log é uma exclusão
                const ultimoLog = logsOrdenados[0];
                const isUltimaOperacaoExclusao =
                  ultimoLog.campo_alteracao === "excluido";

                // Determinar tipo baseado nos campos de alteração
                const temHorarioInicial = logsOrdenados.some(
                  (log) => log.campo_alteracao === "horario_inicial"
                );
                const temHorarioFinal = logsOrdenados.some(
                  (log) => log.campo_alteracao === "horario_final"
                );
                const temInseridoInicial = logsOrdenados.some(
                  (log) => log.campo_alteracao === "inserido_inicial"
                );
                const temInseridoFinal = logsOrdenados.some(
                  (log) => log.campo_alteracao === "inserido_final"
                );
                const temExcluido = logsOrdenados.some(
                  (log) => log.campo_alteracao === "excluido"
                );

                if (temExcluido) {
                  grupo.tipo = "Excluído";
                } else if (temInseridoInicial || temInseridoFinal) {
                  grupo.tipo = "Inserido";
                } else if (temHorarioInicial || temHorarioFinal) {
                  grupo.tipo = "Alterado";
                } else {
                  grupo.tipo = "Alterado";
                }

                // Marcar se deve ser filtrado (última operação foi exclusão)
                grupo.isUltimaOperacaoExclusao = isUltimaOperacaoExclusao;

                // Consolidar horários
                if (isUltimaOperacaoExclusao) {
                  // Se a última operação é exclusão, mostrar apenas os horários da exclusão
                  const logExclusao = logsOrdenados.find(
                    (log) => log.campo_alteracao === "excluido"
                  );
                  if (logExclusao) {
                    grupo.originalInicial = logExclusao.hora_original || "—";
                    grupo.novoInicial = "—";
                    grupo.originalFinal = logExclusao.hora_original || "—";
                    grupo.novoFinal = "—";
                  }
                } else {
                  // Se não é exclusão, processar todos os logs normalmente
                  // Buscar TODOS os logs do mesmo id_marcacao para pegar o valor original do evento
                  // IMPORTANTE: Usar logsData (todos os logs) em vez de logs (logs filtrados)
                  const todosLogsDoEvento = logsData.filter(
                    (log) => log.id_marcacao === grupo.id_marcacao
                  );

                  // Detectar inserções e separar somente alterações reais
                  const hasInseridoInicial = todosLogsDoEvento.some(
                    (log) => log.campo_alteracao === "inserido_inicial"
                  );
                  const hasInseridoFinal = todosLogsDoEvento.some(
                    (log) => log.campo_alteracao === "inserido_final"
                  );

                  const logsHorarioInicial = todosLogsDoEvento.filter(
                    (log) => log.campo_alteracao === "horario_inicial"
                  );
                  const logsHorarioFinal = todosLogsDoEvento.filter(
                    (log) => log.campo_alteracao === "horario_final"
                  );

                  // Encontrar o log com menor hora_alteracao para horário inicial
                  if (logsHorarioInicial.length > 0) {
                    const logOriginalInicial = logsHorarioInicial.reduce(
                      (menor, atual) => {
                        const horaMenor = menor.hora_alteracao;
                        const horaAtual = atual.hora_alteracao;
                        return horaAtual < horaMenor ? atual : menor;
                      }
                    );

                    if (
                      logOriginalInicial.campo_alteracao === "inserido_inicial"
                    ) {
                      grupo.originalInicial = "—";
                    } else {
                      grupo.originalInicial =
                        logOriginalInicial.hora_original || "—";
                    }
                  }

                  // Forçar original inicial como — se houve inserção
                  if (hasInseridoInicial) {
                    grupo.originalInicial = "—";
                  }

                  // Encontrar o log com menor hora_alteracao para horário final
                  if (logsHorarioFinal.length > 0) {
                    const logOriginalFinal = logsHorarioFinal.reduce(
                      (menor, atual) => {
                        const horaMenor = menor.hora_alteracao;
                        const horaAtual = atual.hora_alteracao;
                        return horaAtual < horaMenor ? atual : menor;
                      }
                    );

                    if (logOriginalFinal.campo_alteracao === "inserido_final") {
                      grupo.originalFinal = "—";
                    } else {
                      grupo.originalFinal =
                        logOriginalFinal.hora_original || "—";
                    }
                  }

                  // Forçar original final como — se houve inserção
                  if (hasInseridoFinal) {
                    grupo.originalFinal = "—";
                  }

                  // Depois, processar os logs do grupo atual para obter os valores finais
                  // Primeiro, tentar processar normalmente com os logs filtrados
                  logsOrdenados.forEach((log) => {
                    const campo = log.campo_alteracao;

                    if (campo === "horario_inicial") {
                      // Para horário novo, sempre usar o MAIS RECENTE
                      grupo.novoInicial = log.hora_novo || "—";
                    } else if (campo === "inserido_inicial") {
                      grupo.novoInicial = log.hora_novo || "—";
                    } else if (campo === "horario_final") {
                      // Para horário novo, sempre usar o MAIS RECENTE
                      grupo.novoFinal = log.hora_novo || "—";
                    } else if (campo === "inserido_final") {
                      grupo.novoFinal = log.hora_novo || "—";
                    }
                  });

                  // Se há inserção e algum dos horários não foi preenchido (foi removido pelo filtro),
                  // buscar diretamente dos logs de inserção para garantir que ambos sejam exibidos
                  if ((hasInseridoInicial || hasInseridoFinal) && (!grupo.novoInicial || !grupo.novoFinal)) {
                    // Buscar logs de inserção diretamente de todosLogsDoEvento (todos os logs, não apenas filtrados)
                    const logInseridoInicial = todosLogsDoEvento.find(
                      (log) => log.campo_alteracao === "inserido_inicial"
                    );
                    const logInseridoFinal = todosLogsDoEvento.find(
                      (log) => log.campo_alteracao === "inserido_final"
                    );

                    // Preencher horário inicial se não foi preenchido e encontrou log de inserção
                    if (!grupo.novoInicial && logInseridoInicial) {
                      grupo.novoInicial = logInseridoInicial.hora_novo || "—";
                    }

                    // Preencher horário final se não foi preenchido e encontrou log de inserção
                    if (!grupo.novoFinal && logInseridoFinal) {
                      grupo.novoFinal = logInseridoFinal.hora_novo || "—";
                    }

                    // Se ainda não encontrou, buscar do evento na papeleta como fallback
                    if ((!grupo.novoInicial || !grupo.novoFinal) && papeletaData) {
                      const eventoPapeleta = papeletaData.find(
                        (evento) => evento.id === grupo.id_marcacao
                      );
                      if (eventoPapeleta) {
                        if (!grupo.novoInicial && eventoPapeleta.hora_inicial) {
                          grupo.novoInicial = eventoPapeleta.hora_inicial;
                        }
                        if (!grupo.novoFinal && eventoPapeleta.hora_final) {
                          grupo.novoFinal = eventoPapeleta.hora_final;
                        }
                      }
                    }
                  }
                }
              });

              return Array.from(grupos.values()).sort((a, b) => {
                const dataA = new Date(a.data_original);
                const dataB = new Date(b.data_original);

                if (dataA.getTime() !== dataB.getTime()) {
                  return dataA - dataB;
                }

                const converterHoraParaMinutos = (hora) => {
                  const [horas, minutos] = (hora || "00:00")
                    .split(":")
                    .map(Number);
                  return horas * 60 + minutos;
                };
                const horaA = Math.min(
                  ...a.logs.map((log) =>
                    converterHoraParaMinutos(log.hora_original)
                  )
                );
                const horaB = Math.min(
                  ...b.logs.map((log) =>
                    converterHoraParaMinutos(log.hora_original)
                  )
                );
                return horaA - horaB;
              });
            };

            // Função para verificar se um log corresponde ao estado final na papeleta
            const logCorrespondeAoEstadoFinal = (log) => {
              if (!papeletaData || !log.id_marcacao) return false;

              // Encontrar o evento correspondente na papeleta
              const eventoPapeleta = papeletaData.find(
                (evento) => evento.id === log.id_marcacao
              );
              if (!eventoPapeleta) return false;

              // Verificar se os horários do log correspondem aos horários finais da papeleta
              const campo = log.campo_alteracao;

              if (campo === "horario_inicial" || campo === "inserido_inicial") {
                return log.hora_novo === eventoPapeleta.hora_inicial;
              } else if (
                campo === "horario_final" ||
                campo === "inserido_final"
              ) {
                return log.hora_novo === eventoPapeleta.hora_final;
              }

              return false;
            };

            // Filtrar logs baseado na visão selecionada (mesma lógica da TabelaHistoricoAlteracoes)
            let logsParaExibir;
            if (mostrarTodosLogs) {
              // "Ver todos os logs": incluir todos os logs da API INT_PAPELETA_LOGALTERACOES
              logsParaExibir = logsData.filter((log) => {
                // Excluir apenas interstícios
                const nomeEventoCorreto = obterNomeEventoCorreto(log);
                const isIntersticio =
                  log.id_evento === "000005" ||
                  log.nome_evento?.toLowerCase() === "intersticio" ||
                  log.nome_evento?.toLowerCase() === "intersticío" ||
                  log.nome_evento?.toLowerCase() === "interstício" ||
                  nomeEventoCorreto?.toLowerCase() === "intersticio" ||
                  nomeEventoCorreto?.toLowerCase() === "intersticío" ||
                  nomeEventoCorreto?.toLowerCase() === "interstício";

                return !isIntersticio;
              });
            } else {
              // "Ver apenas alterações finais": mostrar apenas logs que correspondem ao estado final da papeleta
              logsParaExibir = logsData.filter((log) => {
                // Excluir interstícios
                const nomeEventoCorreto = obterNomeEventoCorreto(log);
                const isIntersticio =
                  log.id_evento === "000005" ||
                  log.nome_evento?.toLowerCase() === "intersticio" ||
                  log.nome_evento?.toLowerCase() === "intersticío" ||
                  log.nome_evento?.toLowerCase() === "interstício" ||
                  nomeEventoCorreto?.toLowerCase() === "intersticio" ||
                  nomeEventoCorreto?.toLowerCase() === "intersticío" ||
                  nomeEventoCorreto?.toLowerCase() === "interstício";

                if (isIntersticio) return false;

                // Verificar se o log corresponde ao estado final na papeleta
                return logCorrespondeAoEstadoFinal(log);
              });
            }

            const logsAgrupados = agruparLogsPorMarcacao(logsParaExibir);

            // Para "Ver apenas alterações finais", consolidar por id_marcacao
            let logsFinais;
            if (mostrarTodosLogs) {
              // "Ver todos": mostrar todos os grupos
              logsFinais = logsAgrupados;
            } else {
              // "Ver apenas alterações finais": consolidar por id_marcacao
              const eventosConsolidados = new Map();

              logsAgrupados.forEach((grupo) => {
                const chave = grupo.id_marcacao;

                if (!eventosConsolidados.has(chave)) {
                  eventosConsolidados.set(chave, grupo);
                } else {
                  // Se já existe um evento com este id_marcacao, verificar qual é mais recente
                  const eventoExistente = eventosConsolidados.get(chave);

                  // Comparar pela data/hora da última alteração
                  const ultimaAlteracaoExistente = Math.max(
                    ...eventoExistente.logs.map((log) =>
                      new Date(
                        `${log.data_alteracao}T${log.hora_alteracao}`
                      ).getTime()
                    )
                  );

                  const ultimaAlteracaoNovo = Math.max(
                    ...grupo.logs.map((log) =>
                      new Date(
                        `${log.data_alteracao}T${log.hora_alteracao}`
                      ).getTime()
                    )
                  );

                  // Manter o mais recente
                  if (ultimaAlteracaoNovo > ultimaAlteracaoExistente) {
                    eventosConsolidados.set(chave, grupo);
                  }
                }
              });

              logsFinais = Array.from(eventosConsolidados.values());
            }

            return logsFinais;
          };

          const logsParaPDF = processarLogsPDF();

          // Título da segunda página
          pdf.setFontSize(14);
          pdf.setTextColor(0, 0, 0);
          pdf.setFont("helvetica", "bold");
          pdf.text("Log de Correções", 15, yPos);
          yPos += 8;

          // Subtítulo com informações
          pdf.setFontSize(10);
          pdf.setFont("helvetica", "normal");
          pdf.setTextColor(80, 80, 80);
          pdf.text(
            `Motorista: ${activeMotorista?.nome} | Período: ${formatDate(
              primeiroApto
            )} a ${formatDate(ultimoApto)}`,
            15,
            yPos
          );
          yPos += 8;

          // Função para desenhar o cabeçalho da tabela de logs
          const drawLogsHeader = (yPosition) => {
            pdf.setFontSize(9); // Diminuído de 10 para 9
            pdf.setTextColor(0, 0, 0);
            pdf.setFillColor(240, 240, 240);

            // Desenha o retângulo de fundo do cabeçalho
            pdf.rect(10, yPosition - 4, 230, 9, "FD"); // Diminuído de 10 para 9

            // Desenha as linhas verticais de separação entre colunas
            pdf.setDrawColor(0, 0, 0);
            pdf.line(30, yPosition - 4, 30, yPosition + 5); // Entre Data e Evento - ajustado
            pdf.line(68, yPosition - 4, 68, yPosition + 5); // Entre Evento e Tipo - ajustado
            pdf.line(98, yPosition - 4, 98, yPosition + 5); // Entre Tipo e Orig. Inicial - ajustado
            pdf.line(123, yPosition - 4, 123, yPosition + 5); // Entre Orig. Inicial e Novo Inicial - ajustado
            pdf.line(148, yPosition - 4, 148, yPosition + 5); // Entre Novo Inicial e Orig. Final - ajustado
            pdf.line(173, yPosition - 4, 173, yPosition + 5); // Entre Orig. Final e Novo Final - ajustado
            pdf.line(198, yPosition - 4, 198, yPosition + 5); // Entre Novo Final e Assinatura - ajustado

            // Texto do cabeçalho - centralizado verticalmente
            pdf.setFont("helvetica", "bold");
            pdf.text("Data", 12, yPosition + 2); // Ajustado de yPosition + 1 para yPosition + 2
            pdf.text("Evento", 32, yPosition + 2); // Ajustado de yPosition + 1 para yPosition + 2
            pdf.text("Tipo", 70, yPosition + 2); // Ajustado de yPosition + 1 para yPosition + 2
            pdf.text("Orig. Inicial", 100, yPosition + 2); // Ajustado de yPosition + 1 para yPosition + 2
            pdf.text("Novo Inicial", 125, yPosition + 2); // Ajustado de yPosition + 1 para yPosition + 2
            pdf.text("Orig. Final", 150, yPosition + 2); // Ajustado de yPosition + 1 para yPosition + 2
            pdf.text("Novo Final", 175, yPosition + 2); // Ajustado de yPosition + 1 para yPosition + 2
            pdf.text("Assinatura", 200, yPosition + 2); // Ajustado de yPosition + 1 para yPosition + 2
          };

          // Desenha o primeiro cabeçalho
          drawLogsHeader(yPos);
          yPos += 8;

          pdf.setFontSize(7); // Diminuído de 8 para 7
          pdf.setTextColor(0, 0, 0);

          logsParaPDF.forEach((grupo, index) => {
            // Verifica se precisa de nova página
            if (yPos + 10 > pageHeight - 20) {
              // Diminuído de 12 para 10
              pdf.addPage();
              yPos = 20;
              // Desenha o cabeçalho na nova página
              drawLogsHeader(yPos);
              yPos += 10; // Diminuído de 12 para 10
              // Adiciona identificador na nova página
              adicionarIdentificador();
            }

            // Desenha o fundo da linha (sempre branco para impressão P&B)
            pdf.setFillColor(255, 255, 255);
            pdf.rect(10, yPos - 2, 230, 9, "FD"); // Diminuído de 10 para 9

            // Desenha as linhas verticais de separação entre colunas
            pdf.setDrawColor(0, 0, 0);
            pdf.line(30, yPos - 2, 30, yPos + 7); // Entre Data e Evento - ajustado
            pdf.line(68, yPos - 2, 68, yPos + 7); // Entre Evento e Tipo - ajustado
            pdf.line(98, yPos - 2, 98, yPos + 7); // Entre Tipo e Orig. Inicial - ajustado
            pdf.line(123, yPos - 2, 123, yPos + 7); // Entre Orig. Inicial e Novo Inicial - ajustado
            pdf.line(148, yPos - 2, 148, yPos + 7); // Entre Novo Inicial e Orig. Final - ajustado
            pdf.line(173, yPos - 2, 173, yPos + 7); // Entre Orig. Final e Novo Final - ajustado
            pdf.line(198, yPos - 2, 198, yPos + 7); // Entre Novo Final e Assinatura - ajustado

            // Texto sempre preto para impressão P&B - centralizado verticalmente
            pdf.setFontSize(8); // Diminuído de 9 para 8
            pdf.setTextColor(0, 0, 0);
            pdf.setFont("helvetica", "normal");

            pdf.text(formatDate(grupo.data_original) || "—", 12, yPos + 3); // Ajustado de yPos + 4 para yPos + 3
            // Obter o nome correto do evento
            const nomeEventoCorreto = obterNomeEventoCorreto(grupo);
            pdf.text(nomeEventoCorreto || "—", 32, yPos + 3); // Ajustado de yPos + 4 para yPos + 3

            // Tipo com destaque
            pdf.setFont("helvetica", "bold");
            pdf.text(grupo.tipo, 70, yPos + 3); // Ajustado de yPos + 4 para yPos + 3
            pdf.setFont("helvetica", "normal");

            pdf.text(grupo.originalInicial || "—", 100, yPos + 3); // Ajustado de yPos + 4 para yPos + 3
            pdf.text(grupo.novoInicial || "—", 125, yPos + 3); // Ajustado de yPos + 4 para yPos + 3
            pdf.text(grupo.originalFinal || "—", 150, yPos + 3); // Ajustado de yPos + 4 para yPos + 3
            pdf.text(grupo.novoFinal || "—", 175, yPos + 3); // Ajustado de yPos + 4 para yPos + 3

            yPos += 10; // Diminuído de 12 para 10
          });
        }

        // --- RODAPÉ GERAL ---
        const totalPages = pdf.internal.getNumberOfPages();
        for (let i = 1; i <= totalPages; i++) {
          pdf.setPage(i);

          // Linha separadora
          pdf.setDrawColor(200, 200, 200);
          pdf.line(10, pageHeight - 15, pageWidth - 10, pageHeight - 15);

          // Informações do rodapé
          pdf.setFontSize(8);
          pdf.setTextColor(120, 120, 120);
          pdf.setFont("helvetica", "normal");

          // Informações à esquerda
          pdf.text(`Página ${i} de ${totalPages}`, 10, pageHeight - 10);

          // Informações centralizadas
          const centerText = `Gerado em: ${new Date().toLocaleString("pt-BR")}`;
          const centerTextWidth = pdf.getTextWidth(centerText);
          pdf.text(
            centerText,
            (pageWidth - centerTextWidth) / 2,
            pageHeight - 10
          );
        }

        // Gerar nome do arquivo
        const dataAtual = new Date().toISOString().split("T")[0];
        const tipoVisualizacao = mostrarTodosLogs ? "todos" : "ultimos";
        const nomeMotorista =
          activeMotorista?.nome?.replace(/[^a-zA-Z0-9]/g, "_") || "motorista";
        const periodo = `${primeiroApto}_a_${ultimoApto}`;
        const nomeArquivo = `apontamentos_${nomeMotorista}_${periodo}_${tipoVisualizacao}_${dataAtual}.pdf`;

        pdf.save(nomeArquivo);
        setLoadingPDF(false);

        toast({
          title: "PDF gerado",
          description: "PDF de apontamentos gerado com sucesso",
          status: "success",
          duration: 3000,
          isClosable: true,
        });
      } catch (error) {
        console.error("Erro ao gerar PDF:", error);
        toast({
          title: "Erro ao exportar",
          description: "Ocorreu um erro ao gerar o PDF. Tente novamente.",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
        setLoadingPDF(false);
      }
    }, 500);
  };

  const handleExportXLSX = () => {
    setLoadingXLSX(true);

    setTimeout(() => {
      try {
        if (!papeletaData) {
          toast({
            title: "Erro ao exportar",
            description: "Não há dados para exportar",
            status: "error",
            duration: 3000,
            isClosable: true,
          });
          setLoadingXLSX(false);
          return;
        }

        // Processar dados da tabela (mesma função usada no PDF)
        const dadosTabela = processarDadosTabelaPDF();

        // Calcular totais (mesma lógica da TabelaAgrupada)
        const calcularTotaisXLSX = () => {
          const totais = {
            he50: 0,
            he100: 0,
            adicionalNoturno: 0,
          };

          // Função para calcular HE50 (mesma lógica da TabelaAgrupada)
          const calcularHE50Linha = (eventos) => {
            if (!eventos || eventos.length === 0) return "";
            const semana = eventos[0].semana_texto;
            const obs = eventos[0].obs_compensada?.trim().toLowerCase();
            const isFeriado = obs === "feriado";
            const isDiaEspecial = [
              "dsr_cg",
              "dsr_noutrocidade",
              "falta",
              "afastamento",
              "ferias",
            ].includes(obs || "");
            const isNaoTrabalhadoComCompensacao =
              (!eventos[0].hora_inicial || eventos[0].hora_inicial === ":") &&
              (!eventos[0].hora_final || eventos[0].hora_final === ":") &&
              eventos[0].data_compensada?.trim() !== "";

            if (isNaoTrabalhadoComCompensacao) return "";
            if (isDiaEspecial) return "";
            if (isFeriado) return "00:00";

            const duracao = calcularDuracao(
              eventos[0].hora_inicial,
              eventos[eventos.length - 1].hora_final
            );

            if (duracao === null && !eventos[0].obs_compensada?.trim()) {
              return semana === "Sabado" ? "-04:00" : "-08:00";
            }
            if (duracao === null) {
              return "00:00";
            }
            if (semana === "Domingo" && !eventos[0].data_compensada?.trim()) {
              return "00:00";
            }

            const valor = calcularHE50(
              duracao,
              calcularDiferencaRefeicao(eventos),
              calcularDiferencaDescanso(eventos),
              semana === "Sabado" ? "4:00" : "8:00",
              calcularAdicionalNoturno(eventos)
            );
            if (valor === "-8:00") return "";
            return valor || "00:00";
          };

          const agrupadosPorData = papeletaData.reduce((acc, item) => {
            if (!acc[item.data_inicial]) {
              acc[item.data_inicial] = [];
            }
            acc[item.data_inicial].push(item);
            return acc;
          }, {});

          const diasOrdenados = Object.keys(agrupadosPorData).sort(
            (a, b) => new Date(a) - new Date(b)
          );

          Object.entries(agrupadosPorData).forEach(([dataInicial, eventos]) => {
            const obs = eventos[0].obs_compensada?.trim().toLowerCase();
            const semana = eventos[0].semana_texto;
            const isFeriado = obs === "feriado";

            const jornada = calcularDuracao(
              eventos[0].hora_inicial,
              eventos[eventos.length - 1].hora_final
            );
            const refeicao = calcularDiferencaRefeicao(eventos);
            const descanso = calcularDiferencaDescanso(eventos);
            let adicionalNoturno = calcularAdicionalNoturno(eventos);

            // ⛔ Aplicar a MESMA lógica da TabelaAgrupada: SÓ ignora dias especiais, NÃO ignora jornada 00:00
            const isDiaEspecial = [
              "dsr_noutrocidade",
              "falta",
              "afastamento",
              "ferias",
              "dsr_cg",
            ].includes(obs);

            if (isDiaEspecial) {
              return;
            }

            const isDomingo = semana === "Domingo";
            const isCompensado = eventos[0].data_compensada?.trim() !== "";

            // HE100 só aplica em domingo/feriado quando há jornada > 0 (MESMA lógica da TabelaAgrupada)
            const he100Aplica =
              ((isDomingo && !isCompensado) || isFeriado) &&
              converterParaMinutos(jornada) > 0;
            let he100 = he100Aplica
              ? calcularHE100(
                  jornada,
                  refeicao,
                  descanso,
                  adicionalNoturno,
                  isDomingo,
                  isFeriado
                )
              : "00:00";

            // Usar calcularHE50Linha (MESMA lógica da TabelaAgrupada)
            const he50 = calcularHE50Linha(eventos);

            // Para jornadas nulas ou 00:00, força adicional noturno como 00:00
            if (jornada === "00:00" || jornada === null) {
              adicionalNoturno = "00:00";
            }

            // Somar aos totais usando converterParaMinutos (MESMA lógica da TabelaAgrupada)
            totais.he50 += converterParaMinutos(he50);
            totais.he100 += converterParaMinutos(he100);
            totais.adicionalNoturno += converterParaMinutos(adicionalNoturno);
          });

          const converterMinutosParaHoras = (minutos) => {
            const isNegativo = minutos < 0;
            const minutosAbsolutos = Math.abs(minutos);
            const h = Math.floor(minutosAbsolutos / 60);
            const m = minutosAbsolutos % 60;
            const resultado = `${h}:${m.toString().padStart(2, "0")}`;
            return isNegativo ? `-${resultado}` : resultado;
          };

          return {
            he50: converterMinutosParaHoras(totais.he50),
            he100: converterMinutosParaHoras(totais.he100),
            adicionalNoturno: converterMinutosParaHoras(
              totais.adicionalNoturno
            ),
          };
        };

        const totaisXLSX = calcularTotaisXLSX();

        // Preparar dados para o Excel
        const dadosExcel = dadosTabela.map((linha) => ({
          Dia: formatDate(linha.data),
          "Dia/Semana": linha.diaSemana,
          "H Início": linha.horaInicio,
          "H Fim": linha.horaFim,
          "H Jornada": linha.jornada || "",
          "H Normal": linha.normal || "",
          Refeição: linha.refeicao || "",
          Descanso: linha.descanso || "",
          "HE 50%": linha.he50 || "",
          "HE 100%": linha.he100 || "",
          "Ad. Noturno": linha.adicionalNoturno || "",
          Observação: linha.observacao || "",
          CP: linha.cp || "",
          Placa: linha.placa || "",
        }));

        // Adicionar linha de totais
        dadosExcel.push({
          Dia: "TOTAL",
          "Dia/Semana": "",
          "H Início": "",
          "H Fim": "",
          "H Jornada": "",
          "H Normal": "",
          Refeição: "",
          Descanso: "",
          "HE 50%": totaisXLSX.he50,
          "HE 100%": totaisXLSX.he100,
          "Ad. Noturno": totaisXLSX.adicionalNoturno,
          Observação: "",
          CP: "",
          Placa: "",
        });

        // Adicionar linha em branco
        dadosExcel.push({
          Dia: "",
          "Dia/Semana": "",
          "H Início": "",
          "H Fim": "",
          "H Jornada": "",
          "H Normal": "",
          Refeição: "",
          Descanso: "",
          "HE 50%": "",
          "HE 100%": "",
          "Ad. Noturno": "",
          Observação: "",
          CP: "",
          Placa: "",
        });

        // Adicionar linha de assinatura
        dadosExcel.push({
          Dia: "Assinatura:",
          "Dia/Semana": "",
          "H Início": "",
          "H Fim": "",
          "H Jornada": "",
          "H Normal": "",
          Refeição: "",
          Descanso: "",
          "HE 50%": "",
          "HE 100%": "",
          "Ad. Noturno": "",
          Observação: "",
          CP: "",
          Placa: "",
        });
        dadosExcel.push({
          Dia: activeMotorista?.nome || "",
          "Dia/Semana": "",
          "H Início": "",
          "H Fim": "",
          "H Jornada": "",
          "H Normal": "",
          Refeição: "",
          Descanso: "",
          "HE 50%": "",
          "HE 100%": "",
          "Ad. Noturno": "",
          Observação: "",
          CP: "",
          Placa: "",
        });

        // Adicionar 5 linhas em branco
        for (let i = 0; i < 5; i++) {
          dadosExcel.push({
            Dia: "",
            "Dia/Semana": "",
            "H Início": "",
            "H Fim": "",
            "H Jornada": "",
            "H Normal": "",
            Refeição: "",
            Descanso: "",
            "HE 50%": "",
            "HE 100%": "",
            "Ad. Noturno": "",
            Observação: "",
            CP: "",
            Placa: "",
          });
        }

        // --- LOG DE CORREÇÕES ---
        if (logsData && logsData.length > 0) {
          // Função para encontrar evento correspondente na papeletaData usando id_marcacao
          const encontrarEventoCorrespondente = (log) => {
            if (!papeletaData || !log.id_marcacao) return null;

            // Primeiro tenta encontrar pelo id_marcacao (mais preciso)
            const eventoPorId = papeletaData.find(
              (evento) => evento.id === log.id_marcacao
            );
            if (eventoPorId) return eventoPorId;

            // Se não encontrar, tenta por id_evento + data (fallback)
            return papeletaData.find(
              (evento) =>
                evento.id_evento === log.id_evento &&
                evento.data_inicial === log.data_original
            );
          };

          // Função para obter o nome correto do evento
          const obterNomeEventoCorreto = (log) => {
            // Se temos o evento correspondente na papeleta, usar o nome dele
            const eventoCorrespondente = encontrarEventoCorrespondente(log);
            if (eventoCorrespondente) {
              return (
                eventoCorrespondente.descricao_evento ||
                eventoCorrespondente.nome_evento
              );
            }

            // Caso contrário, usar o nome do log
            return log.nome_evento;
          };

          // Processar logs para XLSX (mesma lógica do PDF)
          const processarLogsXLSX = () => {
            // Função para agrupar logs por id_marcacao
            const agruparLogsPorMarcacao = (logs) => {
              const grupos = new Map();

              logs.forEach((log) => {
                // Chave única: id_marcacao + data_original + nome_evento
                const chave = `${log.id_marcacao || "sem_marcacao"}_${
                  log.data_original
                }_${log.nome_evento}`;

                if (!grupos.has(chave)) {
                  grupos.set(chave, {
                    id_marcacao: log.id_marcacao,
                    data_original: log.data_original,
                    nome_evento: log.nome_evento,
                    nome_motorista: log.nome_motorista,
                    logs: [],
                    tipo: "Alterado",
                    originalInicial: "",
                    novoInicial: "",
                    originalFinal: "",
                    novoFinal: "",
                  });
                }
                grupos.get(chave).logs.push(log);
              });

              // Processar cada grupo
              grupos.forEach((grupo) => {
                // Ordenar logs por data/hora de alteração (mais recente primeiro)
                const logsOrdenados = grupo.logs.sort((a, b) => {
                  const dataA = new Date(
                    `${a.data_alteracao}T${a.hora_alteracao}`
                  );
                  const dataB = new Date(
                    `${b.data_alteracao}T${b.hora_alteracao}`
                  );
                  return dataB - dataA;
                });

                // Função para verificar se um log corresponde ao estado final na papeleta
                const logCorrespondeAoEstadoFinal = (log) => {
                  if (!papeletaData || !log.id_marcacao) return false;

                  const eventoPapeleta = papeletaData.find(
                    (evento) => evento.id === log.id_marcacao
                  );
                  if (!eventoPapeleta) return false;

                  const campo = log.campo_alteracao;

                  if (
                    campo === "horario_inicial" ||
                    campo === "inserido_inicial"
                  ) {
                    return log.hora_novo === eventoPapeleta.hora_inicial;
                  } else if (
                    campo === "horario_final" ||
                    campo === "inserido_final"
                  ) {
                    return log.hora_novo === eventoPapeleta.hora_final;
                  }

                  return false;
                };

                // Para "Ver apenas alterações finais", filtrar logs que correspondem ao estado final
                if (!mostrarTodosLogs) {
                  grupo.logs = grupo.logs.filter((log) =>
                    logCorrespondeAoEstadoFinal(log)
                  );

                  if (grupo.logs.length === 0) {
                    return;
                  }

                  grupo.logs.sort((a, b) => {
                    const dataA = new Date(
                      `${a.data_alteracao}T${a.hora_alteracao}`
                    );
                    const dataB = new Date(
                      `${b.data_alteracao}T${b.hora_alteracao}`
                    );
                    return dataB - dataA;
                  });
                }

                // Verificar se o último log é uma exclusão
                const ultimoLog = logsOrdenados[0];
                const isUltimaOperacaoExclusao =
                  ultimoLog.campo_alteracao === "excluido";

                // Determinar tipo baseado nos campos de alteração
                const temHorarioInicial = logsOrdenados.some(
                  (log) => log.campo_alteracao === "horario_inicial"
                );
                const temHorarioFinal = logsOrdenados.some(
                  (log) => log.campo_alteracao === "horario_final"
                );
                const temInseridoInicial = logsOrdenados.some(
                  (log) => log.campo_alteracao === "inserido_inicial"
                );
                const temInseridoFinal = logsOrdenados.some(
                  (log) => log.campo_alteracao === "inserido_final"
                );
                const temExcluido = logsOrdenados.some(
                  (log) => log.campo_alteracao === "excluido"
                );

                if (temExcluido) {
                  grupo.tipo = "Excluído";
                } else if (temInseridoInicial || temInseridoFinal) {
                  grupo.tipo = "Inserido";
                } else if (temHorarioInicial || temHorarioFinal) {
                  grupo.tipo = "Alterado";
                } else {
                  grupo.tipo = "Alterado";
                }

                // Consolidar horários
                if (isUltimaOperacaoExclusao) {
                  const logExclusao = logsOrdenados.find(
                    (log) => log.campo_alteracao === "excluido"
                  );
                  if (logExclusao) {
                    grupo.originalInicial = logExclusao.hora_original || "—";
                    grupo.novoInicial = "—";
                    grupo.originalFinal = logExclusao.hora_original || "—";
                    grupo.novoFinal = "—";
                  }
                } else {
                  const todosLogsDoEvento = logsData.filter(
                    (log) => log.id_marcacao === grupo.id_marcacao
                  );

                  const hasInseridoInicial = todosLogsDoEvento.some(
                    (log) => log.campo_alteracao === "inserido_inicial"
                  );
                  const hasInseridoFinal = todosLogsDoEvento.some(
                    (log) => log.campo_alteracao === "inserido_final"
                  );

                  const logsHorarioInicial = todosLogsDoEvento.filter(
                    (log) => log.campo_alteracao === "horario_inicial"
                  );
                  const logsHorarioFinal = todosLogsDoEvento.filter(
                    (log) => log.campo_alteracao === "horario_final"
                  );

                  if (logsHorarioInicial.length > 0) {
                    const logOriginalInicial = logsHorarioInicial.reduce(
                      (menor, atual) => {
                        const horaMenor = menor.hora_alteracao;
                        const horaAtual = atual.hora_alteracao;
                        return horaAtual < horaMenor ? atual : menor;
                      }
                    );

                    if (
                      logOriginalInicial.campo_alteracao === "inserido_inicial"
                    ) {
                      grupo.originalInicial = "—";
                    } else {
                      grupo.originalInicial =
                        logOriginalInicial.hora_original || "—";
                    }
                  }

                  if (hasInseridoInicial) {
                    grupo.originalInicial = "—";
                  }

                  if (logsHorarioFinal.length > 0) {
                    const logOriginalFinal = logsHorarioFinal.reduce(
                      (menor, atual) => {
                        const horaMenor = menor.hora_alteracao;
                        const horaAtual = atual.hora_alteracao;
                        return horaAtual < horaMenor ? atual : menor;
                      }
                    );

                    if (logOriginalFinal.campo_alteracao === "inserido_final") {
                      grupo.originalFinal = "—";
                    } else {
                      grupo.originalFinal =
                        logOriginalFinal.hora_original || "—";
                    }
                  }

                  if (hasInseridoFinal) {
                    grupo.originalFinal = "—";
                  }

                  logsOrdenados.forEach((log) => {
                    const campo = log.campo_alteracao;

                    if (campo === "horario_inicial") {
                      grupo.novoInicial = log.hora_novo || "—";
                    } else if (campo === "inserido_inicial") {
                      grupo.novoInicial = log.hora_novo || "—";
                    } else if (campo === "horario_final") {
                      grupo.novoFinal = log.hora_novo || "—";
                    } else if (campo === "inserido_final") {
                      grupo.novoFinal = log.hora_novo || "—";
                    }
                  });
                }
              });

              return Array.from(grupos.values()).sort((a, b) => {
                const dataA = new Date(a.data_original);
                const dataB = new Date(b.data_original);

                if (dataA.getTime() !== dataB.getTime()) {
                  return dataA - dataB;
                }

                const converterHoraParaMinutos = (hora) => {
                  const [horas, minutos] = (hora || "00:00")
                    .split(":")
                    .map(Number);
                  return horas * 60 + minutos;
                };
                const horaA = Math.min(
                  ...a.logs.map((log) =>
                    converterHoraParaMinutos(log.hora_original)
                  )
                );
                const horaB = Math.min(
                  ...b.logs.map((log) =>
                    converterHoraParaMinutos(log.hora_original)
                  )
                );
                return horaA - horaB;
              });
            };

            // Filtrar logs baseado na visão selecionada
            let logsParaExibir;
            if (mostrarTodosLogs) {
              logsParaExibir = logsData.filter((log) => {
                const nomeEventoCorreto = obterNomeEventoCorreto(log);
                const isIntersticio =
                  log.id_evento === "000005" ||
                  log.nome_evento?.toLowerCase() === "intersticio" ||
                  log.nome_evento?.toLowerCase() === "intersticío" ||
                  log.nome_evento?.toLowerCase() === "interstício" ||
                  nomeEventoCorreto?.toLowerCase() === "intersticio" ||
                  nomeEventoCorreto?.toLowerCase() === "intersticío" ||
                  nomeEventoCorreto?.toLowerCase() === "interstício";

                return !isIntersticio;
              });
            } else {
              logsParaExibir = logsData.filter((log) => {
                const nomeEventoCorreto = obterNomeEventoCorreto(log);
                const isIntersticio =
                  log.id_evento === "000005" ||
                  log.nome_evento?.toLowerCase() === "intersticio" ||
                  log.nome_evento?.toLowerCase() === "intersticío" ||
                  log.nome_evento?.toLowerCase() === "interstício" ||
                  nomeEventoCorreto?.toLowerCase() === "intersticio" ||
                  nomeEventoCorreto?.toLowerCase() === "intersticío" ||
                  nomeEventoCorreto?.toLowerCase() === "interstício";

                if (isIntersticio) return false;

                const logCorrespondeAoEstadoFinal = (log) => {
                  if (!papeletaData || !log.id_marcacao) return false;

                  const eventoPapeleta = papeletaData.find(
                    (evento) => evento.id === log.id_marcacao
                  );
                  if (!eventoPapeleta) return false;

                  const campo = log.campo_alteracao;

                  if (
                    campo === "horario_inicial" ||
                    campo === "inserido_inicial"
                  ) {
                    return log.hora_novo === eventoPapeleta.hora_inicial;
                  } else if (
                    campo === "horario_final" ||
                    campo === "inserido_final"
                  ) {
                    return log.hora_novo === eventoPapeleta.hora_final;
                  }

                  return false;
                };

                return logCorrespondeAoEstadoFinal(log);
              });
            }

            const logsAgrupados = agruparLogsPorMarcacao(logsParaExibir);

            // Para "Ver apenas alterações finais", consolidar por id_marcacao
            let logsFinais;
            if (mostrarTodosLogs) {
              logsFinais = logsAgrupados;
            } else {
              const eventosConsolidados = new Map();

              logsAgrupados.forEach((grupo) => {
                const chave = grupo.id_marcacao;

                if (!eventosConsolidados.has(chave)) {
                  eventosConsolidados.set(chave, grupo);
                } else {
                  const eventoExistente = eventosConsolidados.get(chave);

                  const ultimaAlteracaoExistente = Math.max(
                    ...eventoExistente.logs.map((log) =>
                      new Date(
                        `${log.data_alteracao}T${log.hora_alteracao}`
                      ).getTime()
                    )
                  );

                  const ultimaAlteracaoNovo = Math.max(
                    ...grupo.logs.map((log) =>
                      new Date(
                        `${log.data_alteracao}T${log.hora_alteracao}`
                      ).getTime()
                    )
                  );

                  if (ultimaAlteracaoNovo > ultimaAlteracaoExistente) {
                    eventosConsolidados.set(chave, grupo);
                  }
                }
              });

              logsFinais = Array.from(eventosConsolidados.values());
            }

            return logsFinais;
          };

          const logsParaXLSX = processarLogsXLSX();

          // Preparar dados do log para o Excel
          const dadosLogExcel = logsParaXLSX.map((grupo) => {
            // Obter nome do evento correto usando o primeiro log do grupo
            const primeiroLog =
              grupo.logs && grupo.logs.length > 0 ? grupo.logs[0] : null;
            const nomeEventoCorreto = primeiroLog
              ? obterNomeEventoCorreto(primeiroLog)
              : grupo.nome_evento;
            return {
              Data: formatDate(grupo.data_original) || "—",
              Evento: nomeEventoCorreto || "—",
              Tipo: grupo.tipo,
              "Orig. Inicial": grupo.originalInicial || "—",
              "Novo Inicial": grupo.novoInicial || "—",
              "Orig. Final": grupo.originalFinal || "—",
              "Novo Final": grupo.novoFinal || "—",
              Assinatura: "",
            };
          });

          // Adicionar título do log de correções
          dadosExcel.push({
            Dia: "LOG DE CORREÇÕES",
            "Dia/Semana": "",
            "H Início": "",
            "H Fim": "",
            "H Jornada": "",
            "H Normal": "",
            Refeição: "",
            Descanso: "",
            "HE 50%": "",
            "HE 100%": "",
            "Ad. Noturno": "",
            Observação: "",
            CP: "",
            Placa: "",
          });

          // Adicionar cabeçalho do log de correções
          dadosExcel.push({
            Dia: "Data",
            "Dia/Semana": "Evento",
            "H Início": "Tipo",
            "H Fim": "Orig. Inicial",
            "H Jornada": "Novo Inicial",
            "H Normal": "Orig. Final",
            Refeição: "Novo Final",
            Descanso: "Assinatura",
            "HE 50%": "",
            "HE 100%": "",
            "Ad. Noturno": "",
            Observação: "",
            CP: "",
            Placa: "",
          });

          // Adicionar dados do log de correções
          dadosLogExcel.forEach((log) => {
            dadosExcel.push({
              Dia: log.Data,
              "Dia/Semana": log.Evento,
              "H Início": log.Tipo,
              "H Fim": log["Orig. Inicial"],
              "H Jornada": log["Novo Inicial"],
              "H Normal": log["Orig. Final"],
              Refeição: log["Novo Final"],
              Descanso: log.Assinatura,
              "HE 50%": "",
              "HE 100%": "",
              "Ad. Noturno": "",
              Observação: "",
              CP: "",
              Placa: "",
            });
          });
        }

        // Criar workbook e worksheet (após adicionar todos os dados, incluindo logs)
        const wb = XLSX.utils.book_new();
        const ws = XLSX.utils.json_to_sheet(dadosExcel);

        // Ajustar largura das colunas
        const colWidths = [
          { wch: 12 }, // Dia
          { wch: 12 }, // Dia/Semana
          { wch: 10 }, // H Início
          { wch: 10 }, // H Fim
          { wch: 12 }, // H Jornada
          { wch: 12 }, // H Normal
          { wch: 10 }, // Refeição
          { wch: 10 }, // Descanso
          { wch: 10 }, // HE 50%
          { wch: 10 }, // HE 100%
          { wch: 12 }, // Ad. Noturno
          { wch: 20 }, // Observação
          { wch: 12 }, // CP
          { wch: 15 }, // Placa
        ];
        ws["!cols"] = colWidths;

        // Adicionar worksheet ao workbook
        XLSX.utils.book_append_sheet(wb, ws, "Apontamentos");

        // Gerar nome do arquivo
        const dataAtual = new Date().toISOString().split("T")[0];
        const tipoVisualizacao = mostrarTodosLogs ? "todos" : "ultimos";
        const nomeMotorista =
          activeMotorista?.nome?.replace(/[^a-zA-Z0-9]/g, "_") || "motorista";
        const periodo = `${primeiroApto}_a_${ultimoApto}`;
        const nomeArquivo = `apontamentos_${nomeMotorista}_${periodo}_${tipoVisualizacao}_${dataAtual}.xlsx`;

        // Salvar arquivo
        XLSX.writeFile(wb, nomeArquivo);

        setLoadingXLSX(false);

        toast({
          title: "XLSX gerado",
          description: "Arquivo Excel de apontamentos gerado com sucesso",
          status: "success",
          duration: 3000,
          isClosable: true,
        });
      } catch (error) {
        console.error("Erro ao gerar XLSX:", error);
        toast({
          title: "Erro ao exportar",
          description:
            "Ocorreu um erro ao gerar o arquivo Excel. Tente novamente.",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
        setLoadingXLSX(false);
      }
    }, 500);
  };

  const iconesEvento = {
    DIRECAO: "🛣️",
    REFEICAO: "🍽️",
    "TEMPO ESPERA": "⏱️",
    INTERSTICIO: "💤",
    INTERVALO: "☕",
  };

  // Função para agrupar alterações por dia
  const agruparAlteracoesPorDia = (logs) => {
    const logsPorDia = new Map();

    // Filtra logs de interstício antes de processar
    const logsFiltrados = logs.filter((log) => {
      const nomeEvento = log.nome_evento?.toLowerCase();
      const idEvento = log.id_evento;

      // Verificar múltiplas variações do nome interstício
      const isIntersticio =
        nomeEvento === "intersticio" ||
        nomeEvento === "intersticío" ||
        nomeEvento === "interstício" ||
        idEvento === "000005";

      return !isIntersticio;
    });

    logsFiltrados.forEach((log) => {
      const dataOriginal = log.data_original;

      if (!logsPorDia.has(dataOriginal)) {
        logsPorDia.set(dataOriginal, {
          data: dataOriginal,
          eventos: new Map(),
          totalAlteracoes: 0,
        });
      }

      const dia = logsPorDia.get(dataOriginal);

      // Usar id_marcacao para agrupamento mais preciso
      const chaveEvento = `${log.nome_evento}_${log.data_original}_${
        log.nome_motorista
      }_${log.id_marcacao || "sem_marcacao"}`;

      if (!dia.eventos.has(chaveEvento)) {
        dia.eventos.set(chaveEvento, {
          id_evento: log.id_evento,
          id_marcacao: log.id_marcacao,
          nome_evento: log.nome_evento,
          descricao_evento: log.descricao_evento,
          data_inicial: log.data_inicial,
          nome_motorista: log.nome_motorista,
          alteracoes: [],
          originalInicial: "",
          novoInicial: "",
          originalFinal: "",
          novoFinal: "",
          tipos: new Set(),
        });
      }

      const evento = dia.eventos.get(chaveEvento);
      evento.alteracoes.push({
        campo: log.campo_alteracao,
        hora_original: log.hora_original,
        hora_novo: log.hora_novo,
        data_alteracao: log.data_alteracao,
        hora_alteracao: log.hora_alteracao,
        id_marcacao: log.id_marcacao,
      });

      dia.totalAlteracoes++;
    });

    // Processar cada evento para calcular valores finais
    logsPorDia.forEach((dia) => {
      dia.eventos.forEach((evento) => {
        // Ordenar alterações por data/hora
        const alteracoesOrdenadas = evento.alteracoes.sort((a, b) => {
          const dateA = new Date(`${a.data_alteracao}T${a.hora_alteracao}`);
          const dateB = new Date(`${b.data_alteracao}T${b.hora_alteracao}`);
          return dateA - dateB;
        });

        // Processar alterações
        alteracoesOrdenadas.forEach((alteracao) => {
          const campo = alteracao.campo?.toLowerCase();

          if (campo === "inserido_inicial") {
            evento.tipos.add("Inserido");
            evento.originalInicial = "—";
            evento.novoInicial = alteracao.hora_novo;
          } else if (campo === "inserido_final") {
            evento.tipos.add("Inserido");
            evento.originalFinal = "—";
            evento.novoFinal = alteracao.hora_novo;
          } else if (campo === "inserido") {
            evento.tipos.add("Inserido");
            const hour = parseInt(
              (alteracao.hora_novo || "00:00").split(":")[0]
            );
            if (hour < 12) {
              evento.originalInicial = "—";
              evento.novoInicial = alteracao.hora_novo;
            } else {
              evento.originalFinal = "—";
              evento.novoFinal = alteracao.hora_novo;
            }
          } else if (campo === "excluido") {
            evento.tipos.add("Excluído");
            const hour = parseInt(
              (alteracao.hora_original || "00:00").split(":")[0]
            );
            if (hour < 12) {
              evento.originalInicial = alteracao.hora_original;
              evento.novoInicial = "—";
            } else {
              evento.originalFinal = alteracao.hora_original;
              evento.novoFinal = "—";
            }
          } else if (campo === "horario_inicial") {
            if (
              alteracao.hora_original === ":" ||
              !alteracao.hora_original ||
              alteracao.hora_original.trim() === ""
            ) {
              evento.tipos.add("Inserido");
              if (!evento.novoInicial) {
                evento.originalInicial = "—";
                evento.novoInicial = alteracao.hora_novo;
              }
            } else {
              evento.tipos.add("Alterado");
              evento.originalInicial = alteracao.hora_original;
              evento.novoInicial = alteracao.hora_novo;
            }
          } else if (campo === "horario_final") {
            if (
              alteracao.hora_original === ":" ||
              !alteracao.hora_original ||
              alteracao.hora_original.trim() === ""
            ) {
              evento.tipos.add("Inserido");
              if (!evento.novoFinal) {
                evento.originalFinal = "—";
                evento.novoFinal = alteracao.hora_novo;
              }
            } else {
              evento.tipos.add("Alterado");
              evento.originalFinal = alteracao.hora_original;
              evento.novoFinal = alteracao.hora_novo;
            }
          }
        });

        // Determinar tipo final
        if (evento.tipos.has("Inserido") && evento.tipos.has("Excluído")) {
          evento.tipoFinal = "Inserido/Excluído";
        } else if (
          evento.tipos.has("Inserido") &&
          evento.tipos.has("Alterado")
        ) {
          evento.tipoFinal = "Inserido/Alterado";
        } else if (evento.tipos.has("Inserido")) {
          evento.tipoFinal = "Inserido";
        } else if (evento.tipos.has("Excluído")) {
          evento.tipoFinal = "Excluído";
        } else if (evento.tipos.has("Alterado")) {
          evento.tipoFinal = "Alterado";
        } else {
          evento.tipoFinal = "Alterado";
        }
      });

      // Converter Map para Array
      dia.eventos = Array.from(dia.eventos.values());
    });

    // Converter para Array e ordenar por data (mais recente primeiro)
    return Array.from(logsPorDia.values()).sort((a, b) => {
      return new Date(b.data) - new Date(a.data);
    });
  };

  const handleEdit = (dataInicial, eventos) => {
    const normalizarData = (data) =>
      data ? data.split("T")[0].split(" ")[0] : "";
    const logsDoDia = logsData.filter(
      (log) => normalizarData(log.data_original) === normalizarData(dataInicial)
    );

    if (eventos && eventos.length > 0 && eventos[0]?.id_motorista) {
      localStorage.setItem("lastMotoristaId", eventos[0].id_motorista);
    }

    navigate(`/editar/${dataInicial}/`, {
      state: { eventos, logsDoDia },
    });
  };

  return (
    <Box p={4} bg="#F9F9F9" minH="99vh">
      <Box
        bg="white"
        borderRadius="lg"
        p={4}
        boxShadow="md"
        mb={6}
        position="sticky"
        top={0}
        zIndex={10}
      >
        <HStack spacing={6} align="center" width="100%" justify="space-between">
          <HStack spacing={3}>
            <Button
              bg="white"
              variant="outline"
              colorScheme="red"
              onClick={handleGoBack}
              leftIcon={<FaArrowLeft />}
            >
              Voltar
            </Button>
            <HStack spacing={3}>
              <Icon as={FaUser} w={6} h={6} color="red.500" />
              <Text fontSize="lg" fontWeight="bold">
                {activeMotorista?.nome}
              </Text>
            </HStack>
            <HStack spacing={3}>
              <Icon as={FaIdCard} w={6} h={6} color="red.500" />
              <Text fontSize="sm" color="gray.600">
                Código: {activeMotorista?.codigo}
              </Text>
            </HStack>
            <HStack spacing={3}>
              <Icon as={FaCalendarAlt} w={6} h={6} color="red.500" />
              <Input
                type="date"
                value={primeiroApto}
                onChange={(e) =>
                  handleDateChange(
                    setPrimeiroApto,
                    "primeiroApto",
                    e.target.value
                  )
                }
                size="sm"
                maxW="150px"
                bg="white"
              />
            </HStack>
            <HStack spacing={3}>
              <Icon as={FaCalendarCheck} w={6} h={6} color="red.500" />
              <Input
                type="date"
                value={ultimoApto}
                onChange={(e) =>
                  handleDateChange(setUltimoApto, "ultimoApto", e.target.value)
                }
                size="sm"
                maxW="150px"
                bg="white"
              />
            </HStack>
            <Button
              colorScheme="red"
              leftIcon={loading ? <Spinner size="sm" /> : <FaSearch />}
              size="sm"
              onClick={handleManualSearch}
              isLoading={loading}
              loadingText="Pesquisando..."
              disabled={loading}
            >
              {loading ? "Pesquisando..." : "Pesquisar"}
            </Button>
          </HStack>
          <HStack spacing={4} align="center" justify="flex-end">
            <Button
              colorScheme="red"
              onClick={handleExportPDF}
              leftIcon={loadingPDF ? <Spinner size="sm" /> : <FaSave />}
              isLoading={loadingPDF}
              loadingText="Gerando PDF..."
              disabled={loadingPDF || loadingXLSX}
            >
              {loadingPDF ? "Gerando PDF..." : "Exportar PDF"}
            </Button>
            <Button
              colorScheme="green"
              onClick={handleExportXLSX}
              leftIcon={loadingXLSX ? <Spinner size="sm" /> : <FaFileExcel />}
              isLoading={loadingXLSX}
              loadingText="Gerando XLSX..."
              disabled={loadingXLSX || loadingPDF}
            >
              {loadingXLSX ? "Gerando XLSX..." : "Exportar XLSX"}
            </Button>
            <Image
              src={motorasAppLogo}
              alt="Logo Motoras App"
              boxSize="60px"
              objectFit="contain"
            />
          </HStack>
        </HStack>
      </Box>

      {loading ? (
        <Box
          p={4}
          bg="#F9F9F9"
          display="flex"
          justifyContent="center"
          alignItems="center"
          height="95vh"
        >
          <Spinner size="xl" />
        </Box>
      ) : error ? (
        <Box
          p={6}
          mt={4}
          borderRadius="xl"
          bg="red.50"
          border="2px solid"
          borderColor="red.200"
          boxShadow="lg"
          maxW="800px"
          mx="auto"
        >
          <Flex direction="column" align="center" gap={4}>
            <Box bg="red.100" p={3} borderRadius="full">
              <MdWarning color="#E31E2C" size={32} />
            </Box>
            <VStack spacing={3} align="center">
              <Heading size="md" color="red.600" textAlign="center">
                Licença Indisponível
              </Heading>
              <Text
                fontSize="sm"
                color="red.500"
                textAlign="center"
                maxW="600px"
              >
                O servidor de licenças não possui licenças disponíveis no
                momento.
                <br />
                Por favor, tente novamente em alguns instantes ou entre em
                contato com o suporte técnico.
              </Text>
              <Text fontSize="xs" color="gray.500" mt={2}>
                Status: 503 Service Unavailable
              </Text>
            </VStack>
            <Button
              mt={2}
              colorScheme="red"
              variant="outline"
              onClick={() => window.location.reload()}
              leftIcon={<MdRefresh />}
              size="sm"
            >
              Tentar Novamente
            </Button>
          </Flex>
        </Box>
      ) : papeletaData ? (
        <Box
          id="tabela-apontamentos"
          bg="white"
          p={4}
          borderRadius="lg"
          boxShadow="sm"
        >
          <TabelaAgrupada data={papeletaData} logsData={logsData} />
        </Box>
      ) : null}

      <TabelaHistoricoAlteracoes
        logsData={logsData}
        papeletaData={papeletaData}
        mostrarTodosLogs={mostrarTodosLogs}
        setMostrarTodosLogs={setMostrarTodosLogs}
        loadingLogs={loadingLogs}
        iconesEvento={iconesEvento}
      />

      {/* Nova Tabela de Histórico por Dia */}
      {loadingLogs ? (
        <Box
          p={4}
          bg="#F9F9F9"
          display="flex"
          justifyContent="center"
          alignItems="center"
          height="200px"
        >
          <Spinner size="xl" />
        </Box>
      ) : logsData.length > 0 ? (
        <Box
          bg="white"
          p={6}
          borderRadius="lg"
          boxShadow="md"
          mt={6}
          borderLeft="6px solid #3182CE"
        >
          <HStack justifyContent="space-between" mb={4}>
            <Text
              fontSize="xl"
              fontWeight="bold"
              color="gray.700"
              display="flex"
              alignItems="center"
              gap={2}
            >
              <MdHistory color="#3182CE" /> Histórico Detalhado por Dia
            </Text>
            <HStack spacing={3}>
              <Badge colorScheme="blue" fontSize="sm" p={2}>
                {logsData.length} alterações registradas
              </Badge>
              <Button
                size="sm"
                colorScheme="blue"
                variant="outline"
                onClick={() =>
                  setMostrarDetalhesCompletos(!mostrarDetalhesCompletos)
                }
                leftIcon={
                  mostrarDetalhesCompletos ? <MdExpandLess /> : <MdExpandMore />
                }
              >
                {mostrarDetalhesCompletos
                  ? "Recolher Detalhes"
                  : "Expandir Detalhes"}
              </Button>
            </HStack>
          </HStack>

          {agruparAlteracoesPorDia(logsData).map((dia, index) => (
            <Box
              key={index}
              mb={6}
              border="1px solid"
              borderColor="gray.200"
              borderRadius="lg"
              overflow="hidden"
            >
              {/* Cabeçalho do Dia */}
              <Box
                bg="blue.50"
                p={3}
                borderBottom="1px solid"
                borderColor="gray.200"
              >
                <HStack justify="space-between" align="center">
                  <HStack>
                    <Icon as={FaCalendarAlt} color="blue.600" />
                    <Text fontWeight="bold" color="blue.800" fontSize="lg">
                      {formatDate(dia.data)}
                    </Text>
                  </HStack>
                  <HStack spacing={2}>
                    <Badge colorScheme="blue" variant="subtle">
                      {dia.eventos.length} eventos
                    </Badge>
                    <Badge colorScheme="green" variant="subtle">
                      {dia.totalAlteracoes} alterações
                    </Badge>
                  </HStack>
                </HStack>
              </Box>

              {/* Eventos do Dia */}
              {dia.eventos.map((evento, eventoIndex) => (
                <Box
                  key={eventoIndex}
                  p={4}
                  bg={eventoIndex % 2 === 0 ? "gray.50" : "white"}
                >
                  {/* Cabeçalho do Evento */}
                  <HStack mb={3} justify="space-between" align="center">
                    <HStack spacing={3}>
                      <Box fontSize="2xl">
                        {iconesEvento[evento.nome_evento?.toUpperCase()] ||
                          "❓"}
                      </Box>
                      <VStack align="start" spacing={0}>
                        <Text fontWeight="bold" color="gray.700">
                          {evento.nome_evento}
                        </Text>
                        <Text fontSize="sm" color="gray.500">
                          ID: {evento.id_evento}
                        </Text>
                      </VStack>
                    </HStack>
                    <Badge
                      colorScheme={
                        evento.tipoFinal === "Inserido"
                          ? "green"
                          : evento.tipoFinal === "Excluído"
                          ? "red"
                          : evento.tipoFinal === "Alterado"
                          ? "yellow"
                          : "purple"
                      }
                      size="lg"
                    >
                      {evento.tipoFinal}
                    </Badge>
                  </HStack>

                  {/* Resumo das Alterações */}
                  <Box mb={3}>
                    <SimpleGrid columns={2} spacing={4}>
                      <Box>
                        <Text
                          fontSize="sm"
                          fontWeight="semibold"
                          color="gray.600"
                          mb={1}
                        >
                          Horário Inicial
                        </Text>
                        <HStack spacing={2}>
                          <Text fontSize="sm" color="gray.500">
                            De: {evento.originalInicial || "—"}
                          </Text>
                          <Icon as={FaArrowRight} color="gray.400" size="xs" />
                          <Text
                            fontSize="sm"
                            fontWeight="medium"
                            color="green.600"
                          >
                            Para: {evento.novoInicial || "—"}
                          </Text>
                        </HStack>
                      </Box>
                      <Box>
                        <Text
                          fontSize="sm"
                          fontWeight="semibold"
                          color="gray.600"
                          mb={1}
                        >
                          Horário Final
                        </Text>
                        <HStack spacing={2}>
                          <Text fontSize="sm" color="gray.500">
                            De: {evento.originalFinal || "—"}
                          </Text>
                          <Icon as={FaArrowRight} color="gray.400" size="xs" />
                          <Text
                            fontSize="sm"
                            fontWeight="medium"
                            color="green.600"
                          >
                            Para: {evento.novoFinal || "—"}
                          </Text>
                        </HStack>
                      </Box>
                    </SimpleGrid>
                  </Box>

                  {/* Timeline das Alterações - Só mostra quando expandido */}
                  {mostrarDetalhesCompletos && (
                    <Box>
                      <Text
                        fontSize="sm"
                        fontWeight="semibold"
                        color="gray.600"
                        mb={2}
                      >
                        Timeline de Alterações ({evento.alteracoes.length}{" "}
                        alterações)
                      </Text>
                      <VStack spacing={2} align="stretch">
                        {evento.alteracoes.map((alteracao, altIndex) => (
                          <Box
                            key={altIndex}
                            p={2}
                            bg="white"
                            borderRadius="md"
                            border="1px solid"
                            borderColor="gray.200"
                          >
                            <HStack justify="space-between" align="center">
                              <HStack spacing={3}>
                                <Box
                                  w={2}
                                  h={2}
                                  bg="blue.400"
                                  borderRadius="full"
                                />
                                <VStack align="start" spacing={0}>
                                  <Text fontSize="sm" fontWeight="medium">
                                    {alteracao.campo === "inserido_inicial"
                                      ? "Inserção Horário Inicial"
                                      : alteracao.campo === "inserido_final"
                                      ? "Inserção Horário Final"
                                      : alteracao.campo === "inserido"
                                      ? "Inserção"
                                      : alteracao.campo === "excluido"
                                      ? "Exclusão"
                                      : alteracao.campo === "horario_inicial"
                                      ? "Alteração Horário Inicial"
                                      : alteracao.campo === "horario_final"
                                      ? "Alteração Horário Final"
                                      : alteracao.campo}
                                  </Text>
                                  <Text fontSize="xs" color="gray.500">
                                    {formatDate(alteracao.data_alteracao)} às{" "}
                                    {alteracao.hora_alteracao}
                                  </Text>
                                </VStack>
                              </HStack>
                              <HStack spacing={2}>
                                {alteracao.hora_original &&
                                  alteracao.hora_original !== ":" && (
                                    <Text fontSize="sm" color="red.500">
                                      {alteracao.hora_original}
                                    </Text>
                                  )}
                                {alteracao.hora_original &&
                                  alteracao.hora_original !== ":" && (
                                    <Icon
                                      as={FaArrowRight}
                                      color="gray.400"
                                      size="xs"
                                    />
                                  )}
                                <Text
                                  fontSize="sm"
                                  fontWeight="medium"
                                  color="green.600"
                                >
                                  {alteracao.hora_novo}
                                </Text>
                              </HStack>
                            </HStack>
                          </Box>
                        ))}
                      </VStack>
                    </Box>
                  )}

                  {/* Indicador de mais detalhes quando minimizado */}
                  {!mostrarDetalhesCompletos && (
                    <Box mt={2}>
                      <Button
                        size="xs"
                        colorScheme="blue"
                        variant="ghost"
                        onClick={() => setMostrarDetalhesCompletos(true)}
                        leftIcon={<MdExpandMore />}
                      >
                        Ver {evento.alteracoes.length} alterações detalhadas
                      </Button>
                    </Box>
                  )}
                </Box>
              ))}
            </Box>
          ))}
        </Box>
      ) : null}

      <Center mt={4}>
        {/* <Button colorScheme="red" onClick={handleExportPDF}>
          Exportar PDF
        </Button> */}
      </Center>
      <Center>
        <Image
          src={LogotipoNexus}
          alt="Logo Motoras App"
          boxSize="100px"
          objectFit="contain"
        />
      </Center>

      {/* SSL Certificate Helper Modal */}
      <SSLCertificateHelper
        isOpen={sslHelperDisclosure.isOpen}
        onClose={sslHelperDisclosure.onClose}
        error={sslError}
        baseUrl={sslError?.baseUrl}
      />
    </Box>
  );
}

export default Apontamentos;
